import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";

function DocumentPDF({ data }) {
  const { t } = useTranslation();
  const { dateHeader, tableValues, img1, img2 } = data;
  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <View>
          <Text style={styles.date}>
            {t("containers.ReportsPaymentMethods.report") + dateHeader}
          </Text>

          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 0px 5px 0px",
              backgroundColor: "#f9f9f9",
              flexWrap: "wrap",
              gap: 20,
            }}
          >
            <Text style={styles.title}>
              {t("containers.ReportsPaymentMethods.paymentMethods")}
            </Text>
          </View>
        </View>

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "10px 10px 0px 10px",
          }}
        >
          <Image src={img1} style={{ width: "250px" }} />
          <Image src={img2} style={{ width: "250px" }} />
        </View>

        <View style={{ marginTop: 30 }}>
          <Text style={styles.title}>
            {t("containers.ReportsPaymentMethods.paymentMethods")}
          </Text>

          <View
            style={[
              styles.row,
              styles.header,
              {
                fontSize: "8px",
                backgroundColor: "#f9f9f9",
              },
            ]}
          >
            <Text style={styles.row1}>
              {t("containers.ReportsPaymentMethods.method")}
            </Text>
            <Text style={styles.row2}>
              {t("containers.ReportsPaymentMethods.sells")}
            </Text>
            <Text style={styles.row3}>
              {t("containers.ReportsPaymentMethods.returns")}
            </Text>
            <Text style={styles.row4}>
              {t("containers.ReportsPaymentMethods.operations")}
            </Text>
            <Text style={styles.row5}>
              {t("containers.ReportsPaymentMethods.earnings")}
            </Text>
          </View>
          {tableValues.map((row, i) => {
            const values = Object.values(row);
            return (
              <View key={i} style={styles.row} wrap={false}>
                <Text style={styles.row1}>{values[0]}</Text>
                <Text style={styles.row2}>{values[1]}</Text>
                <Text style={styles.row3}>{values[2]}</Text>
                <Text style={styles.row4}>{values[3]}</Text>
                <Text style={styles.row5}>{values[4]}</Text>
              </View>
            );
          })}
        </View>
      </Page>
    </Document>
  );
}
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 20,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.background_dividers,
    marginBottom: 15,
  },
  date: {
    fontSize: 8,
    fontWeight: 300,
    marginTop: -20,
    marginBottom: 20,
    textAlign: "right",
  },
  title: {
    fontSize: 8,
    fontWeight: 500,
    marginBottom: 5,
    paddingHorizontal: 10,
  },
  textIfo: {
    fontSize: 8,
    fontWeight: 300,
    marginBottom: 10,
  },
  textIfoName: {
    fontSize: 8,
    fontWeight: 300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 8,
    paddingBottom: 8,
    marginHorizontal: 10,
  },
  row1: {
    width: "20%",
    fontSize: 8,
    marginLeft: 5,
  },
  row2: {
    width: "20%",
    fontSize: 8,
    marginLeft: 5,
  },
  row3: {
    width: "20%",
    fontSize: 8,
    marginLeft: 5,
  },
  row4: {
    width: "20%",
    fontSize: 8,
    marginLeft: 5,
  },
  row5: {
    width: "20%",
    fontSize: 8,
    marginLeft: 5,
    textAlign: "right",
  },
  containerItems: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  containerPrices: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "70%",
  },
  mapItems: {
    width: "100%",
  },
  items: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
export default DocumentPDF;
